import { create } from 'zustand';
import { adminSyncResultApi } from '@api/api-config.ts';
import { SyncResultItem, SyncResultSummaryRow } from './types.ts';

export interface SyncResultFilters {
  syncType?: string;
  outcome?: string;
  sourceId?: string;
  syncRequestId?: number;
  author?: string;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminSyncResultStoreState {
  loading: boolean;
  error: string | null;
  data: SyncResultItem[] | null;
  pagination: PaginationInfo | null;
  summary: SyncResultSummaryRow[] | null;
  loadSyncResults: (filters: SyncResultFilters) => Promise<void>;
}

export const useAdminSyncResultStore = create<AdminSyncResultStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,
  summary: null,

  loadSyncResults: async (filters: SyncResultFilters) => {
    try {
      set({ loading: true, error: null });
      const [listResp, summaryResp] = await Promise.all([
        adminSyncResultApi.getSyncResults({
          page: filters.page,
          size: filters.size,
          syncType: filters.syncType || undefined,
          outcome: filters.outcome || undefined,
          sourceId: filters.sourceId?.trim() ? filters.sourceId.trim() : undefined,
          syncRequestId: filters.syncRequestId,
          author: filters.author?.trim() ? filters.author.trim() : undefined,
        }),
        adminSyncResultApi.getSyncResultSummary({ syncRequestId: filters.syncRequestId }),
      ]);
      const result = listResp.data;
      set({
        loading: false,
        error: null,
        data: (result.items || []) as unknown as SyncResultItem[],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
        summary: (summaryResp.data || []) as unknown as SyncResultSummaryRow[],
      });
    } catch (error) {
      set({ loading: false, error: error instanceof Error ? error.message : 'Chyba pri nacitani sync resultu' });
    }
  },
}));
